import { render, staticRenderFns } from "./ProductStats.vue?vue&type=template&id=4964cccf"
import script from "./ProductStats.vue?vue&type=script&lang=js"
export * from "./ProductStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports